import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Section';
import { painPoints } from '../data/offer';
export function Pain() {
  return <Section id="problema" eyebrow="El verdadero problema" dark data-id="element-81" data-mp="1nypxa84wrdvz">
      <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-82" data-mp="1j0entyiiz5ea">
        Nadie te habló de la{' '}
        <span className="text-flame-500" data-id="element-83" data-mp="1e4zbjb061hjz">carga de interferencia</span>
      </h2>
      <p className="mt-6 text-lg leading-relaxed text-zinc-400" data-id="element-84" data-mp="1a2cfexwgpagz">
        El problema de la mayoría de los planes es que no la entienden. Y así se ve en la
        práctica:
      </p>

      <ul className="mt-8 space-y-3" data-id="element-85" data-mp="10bzuv5ondhau">
        {painPoints.map(point => <li key={point} className="flex items-start gap-4 rounded-lg border border-ink-700 bg-ink-950 p-5" data-id="element-86" data-mp="vcwtbv7vlt7m">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-87" data-mp="qf4z2ujrdv09">
              <XIcon className="h-4 w-4 text-red-400" aria-hidden="true" data-id="element-88" data-mp="1yx9mlq0bddgh" />
            </span>
            <p className="text-base leading-relaxed text-zinc-300" data-id="element-89" data-mp="1yvgbnyio472o">{point}</p>
          </li>)}
      </ul>

      <p className="mt-8 font-display text-3xl font-extrabold uppercase italic leading-tight text-white" data-id="element-90" data-mp="1oz3ir2uy5x8z">
        Entrenar duro no es suficiente.{' '}
        <span className="text-flame-500" data-id="element-91" data-mp="1typxxhuc5nkf">Tenés que entrenar inteligente.</span>
      </p>
      <p className="mt-4 text-lg leading-relaxed text-zinc-400" data-id="element-92" data-mp="2hp2f7jbh0wno">
        Necesitás un sistema que coordine tu fuerza y tu resistencia para que una potencie
        a la otra.
      </p>
    </Section>;
}